import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loader from '../../components/loader';
import ToastHandler from '../../components/toasthandler';

import {
  approveWithdrawal,
  denyWithdrawal,
} from '../../actions';

const qs = require('query-string');

class ConfirmWithdrawal extends Component {
  constructor(props) {
    super(props);
    const urlParams = qs.parse(this.props.location.search);
    this.state = {
      urlParams,
      loading: false,
      updateFail: false,
      approved: false,
      denied: false,
    };
    this.approveConfirmation = this.approveConfirmation.bind(this);
    this.denyConfirmation = this.denyConfirmation.bind(this);
    this.bodyRender = this.bodyRender.bind(this);
  }

  approveConfirmation() {
    const { dispatch } = this.props;
    const { urlParams } = this.state;

    const approvalId = urlParams.approvalId;

    if (approvalId) {
      const data = {
        approvalId,
      }
      this.setState({ loading: true, confirmFail: false })
      dispatch(approveWithdrawal(data))
      .then(res => {
        if (res.type === 'APPROVE_WITHDRAWAL_SUCCESS') {
          this.setState({ approved: true, loading: false })
        }
        if (res.type === 'APPROVE_WITHDRAWAL_FAIL') {
          this.setState({ confirmFail: true, loading: false })
        }
      });
    }
  }

  denyConfirmation() {
    const { dispatch } = this.props;
    const { urlParams } = this.state;

    const approvalId = urlParams.approvalId;

    if (approvalId) {
      const data = {
        approvalId,
      }
      this.setState({ loading: true, confirmFail: false })
      dispatch(denyWithdrawal(data))
      .then(res => {
        if (res.type === 'DENY_WITHDRAWAL_SUCCESS') {
          this.setState({ denied: true, loading: false })
        }
        if (res.type === 'DENY_WITHDRAWAL_FAIL') {
          this.setState({ confirmFail: true, loading: false })
        }
      });
    }
  }

  bodyRender() {
    const { loading, urlParams, approved, denied, confirmFail } = this.state;

    const approvalId = urlParams.approvalId;

    const decided = approved || denied;

    if (loading) {
      return (
        <div className="center-loader">
          <Loader logo />
        </div>
      );
    }

    if (confirmFail || !approvalId) {
      return (
        <div className="cell panel small-12 medium-8 large-5 text-center">
          <h1>Withdrawal Confirmation Unsuccessful</h1>
          <p>There was a problem confirming your withdrawal.</p>
          <p>Please contact support if this persists.</p>
          <div className="button-area lr-b" style={{ marginTop: '20px' }}>
            <a
              href="/"
              className="vlt-button dark-b"
            >
              <span>
                Return to Dashboard
              </span>
            </a>
          </div>
        </div>
      );
    }

    if (denied) {
      return (
        <div className="cell panel small-12 medium-8 large-5 text-center">
          <h1>Withdrawal Denied</h1>
          <p>Your withdrawal has successfully been denied.</p>
          <p>We&apos;ve blocked this address permanently.</p>
          <div className="button-area lr-b" style={{ marginTop: '20px' }}>
            <a
              href="/"
              className="vlt-button dark-b"
            >
              <span>
                Return to Dashboard
              </span>
            </a>
          </div>
        </div>
      );
    }

    if (approved) {
      return (
        <div className="cell panel small-12 medium-8 large-5 text-center">
          <h1>Withdrawal Approved</h1>
          <p>Your withdrawal has successfully been approved.</p>
          <p>Funds will be transfered shortly.</p>
          <div className="button-area lr-b" style={{ marginTop: '20px' }}>
            <a
              href="/"
              className="vlt-button dark-b"
            >
              <span>
                Return to Dashboard
              </span>
            </a>
          </div>
        </div>
      );
    }

    return (
      <div className="cell panel small-12 medium-8 large-5 text-center">
        <h1>Withdrawal Confirmation</h1>
        <p>Approve or deny your withdrawal request by clicking below.</p>
        <div className="button-area lr-b" style={{ marginTop: '20px' }}>
          <button
            className="vlt-button vlt-green"
            onClick={() => this.approveConfirmation()}
            disabled={decided}
          >
            <span>
              Approve
            </span>
          </button>
          <button
            className="vlt-button vlt-red"
            onClick={() => this.denyConfirmation()}
            disabled={decided}
          >
            <span>
              Deny
            </span>
          </button>
        </div>
      </div>
    );
  }


  render() {
    const { errors, success } = this.props;

    return (
      <div className="grid-x align-center">
        <ToastHandler errors={errors} success={success} />
        {this.bodyRender()}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  errors: state.coins.errors,
  success: state.coins.success,
});

export default connect(mapStateToProps)(ConfirmWithdrawal);
